import "react-toggle/style.css";

import React, { useEffect, useState } from "react";
import { Col, Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import FieldSelect from "../Fields/FieldSelect";

import AddOrEditMediaPackageOutput from "./AddOrEditMediaPackageOutput";
import AddOrEditFacebookOutput from "./AddOrEditFacebookOutput";
import AddOrEditRmtpOutput from "./AddOrEditRmtpOutput";
import AddOrEditS3Output from "./AddOrEditS3Output";
import AddOrEditYoutubeOutput from "./AddOrEditYoutubeOutput";
import AlertComponent from "../AlertComponent";

function AddOrEditOutput(props) {
  const {
    handleAddNewElementsOutput,
    hasS3,
    hasMediaPackage,
    handleCancelOutput,
    currentElement,
  } = props;
  const [outputData, setOutputData] = useState(currentElement);
  const [outputName, setOutputName] = useState(null);
  const [outputTypeSelected, setInputTypeSelected] = useState({});
  const [outputTypeOptions, setOutputTypeOptions] = useState([]);

  const addNewElementsOutput = (item) => {
    if (item.name.includes(" ")) {
      return AlertComponent("Error", "Spaces are not allowed for output name", {
        icon: `error`,
      });
    }
    handleAddNewElementsOutput(item);
    return AlertComponent("Success", `Output ${item.id ? "edited" : "added"} successfully`);
  };

  useEffect(() => {
    let outputOpts = [
      { value: 4, label: "Media Package - HLS" },
      { value: 5, label: "Facebook" },
      { value: 6, label: "RTMP" },
      { value: 7, label: "s3" },
      { value: 8, label: "Youtube - Channel" },
    ];

    if (hasS3) {
      outputOpts.splice(3, 1);
    }

    if (hasMediaPackage) {
      outputOpts.splice(0, 1);
    }

    setOutputTypeOptions(outputOpts);
  }, [0]);

  useEffect(() => {
    if (outputData && outputTypeOptions.length) {
      setOutputName(outputData.name)
      switch (outputData.outputType) {
        case "Facebook":
          const facebookIndex = outputTypeOptions.findIndex(item => item.label === "Facebook");
          setInputTypeSelected(outputTypeOptions[facebookIndex]);
          break;
        case "RTMP":
          const rtmpIndex = outputTypeOptions.findIndex(item => item.label === "RTMP");
          setInputTypeSelected(outputTypeOptions[rtmpIndex]);
          break;
        case "YouTube":
          const youtubeIndex = outputTypeOptions.findIndex(item => item.label === "Youtube - Channel");
          setInputTypeSelected(outputTypeOptions[youtubeIndex]);
          break;
      }
    }
  }, [outputData, outputTypeOptions]);

  return (
    <Col className="new-channel-outputs">
      <div>
        <div className="add-new-channel-container">
          <div className="left-item">
            <h3>Adding Output</h3>
          </div>
          <div className={`right-item`}>
            <Button
              className="small-btn-cancel"
              variant="outline-primary"
              size="sm"
              onClick={handleCancelOutput}
            >
              Cancel
            </Button>
          </div>
        </div>

        <FieldText
          label="Output Name"
          type="text"
          onChange={(x) => setOutputName(x.target.value)}
          placeholder="Output Name"
          value={outputName}
          className="col-md-12"
          required={true}
          inputClassName={`inputOption`}
        />

        <FieldSelect
          label={`Select Output Type`}
          options={outputTypeOptions}
          className={`col-md-12`}
          id={`inputTypeSelected`}
          name={`inputTypeSelected`}
          onChange={setInputTypeSelected}
          value={outputTypeSelected}
          placeholder={`Choose Channel`}
          readonly={outputData}
        />

        {outputTypeSelected.value === 4 && (
          <AddOrEditMediaPackageOutput
            outputName={outputName}
            handleAddNewElementsOutput={addNewElementsOutput}
          />
        )}

        {outputTypeSelected.value === 5 && (
          <AddOrEditFacebookOutput
            outputName={outputName}
            handleAddNewElementsOutput={addNewElementsOutput}
            currentElement={outputData}
          />
        )}

        {outputTypeSelected.value === 6 && (
          <AddOrEditRmtpOutput
            outputName={outputName}
            handleAddNewElementsOutput={addNewElementsOutput}
            currentElement={outputData}
          />
        )}

        {outputTypeSelected.value === 7 && (
          <AddOrEditS3Output
            outputName={outputName}
            handleAddNewElementsOutput={addNewElementsOutput}
          />
        )}

        {outputTypeSelected.value === 8 && (
          <AddOrEditYoutubeOutput
            outputName={outputName}
            handleAddNewElementsOutput={addNewElementsOutput}
            currentElement={outputData}
          />
        )}
      </div>
    </Col>
  );
}

export default AddOrEditOutput;
